import React, { useEffect, useCallback, useState, useMemo } from "react";
import jsbridge from "@xpeng/js-bridge";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import request from "../../../network/request";
import useBaseInfo from "../store/useBaseInfo";
import useSelfArrivalCity from "../store/useSelfArrivalCity";
import useBasicFormData from "../store/useBasicFormData";
import useCitiesData from "../store/useCitiesData";
import { getLocationFromApp } from "../common/funcs";
import {
  DEFAULT_CITY_CODE,
  ORDER_TAB_LIST,
  ORDER_TAB_MAP,
} from "../config/constants";
import { STORE_ITEMS_CAPACITY } from "../interfaces/home";
import { CommonLoadingComp } from "../../../components/CommonLoading";
import EmptyPlaceHolder from "../components/EmptyPlaceHolder";
import { getDistanceText, MUNICIPALITY_PROVINCE_CODES } from "../../../utils/common";
import { sendReport } from "../../../utils/reporter";
import { ReactComponent as PositionIcon } from "../../../assets/svgicons/position.svg";
import ScoreLine from "../components/ScoreLine";
import { Tabs, Tab, TabList } from "react-tabs";
import classnames from "classnames";
import "./index.scss";
import { ErrorPlaceholder } from "../../../components/placeholder";
import useHashModal from "../../../hooks/useHashModal";

export default function StoreSelector(props) {
  const { serviceItems, eventCode, childServiceItems } = props;
  const history = useHistory();
  const { baseInfo, setContentEdited } = useBaseInfo();
  const { selfArrivalCity, setSelfArrivalCity } = useSelfArrivalCity();
  const { data: provincesCitiesData } = useCitiesData();
  const {
    setDatesContentOfStoreTab,
    setStoreContentOfStoreTab,
    setDatesStoreContentOfDateTab,
    setModifyOrderArriveStoreTime,
    setModifyOrderShopCode,
  } = useBasicFormData();
  const [isLoading, setIsLoading] = useState(true);
  const [locationMsg, setLocationMsg] = useState<any>({});
  const [cityStoreList, setCityStoreList] = useState<STORE_ITEMS_CAPACITY[]>(
    []
  );
  const [curTab, setCurTab] = useState<number>(ORDER_TAB_MAP.COMPREHENSIVE);
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const { visible } = useHashModal("#select-store", {
    title: "更换门店",
    onShow: () => {
      sendReport({
        mcode: "更换门店页面访问量",
        point: "P11185`B001",
        type: "page",
      });
    },
  });

  const getCityWithLocation = useCallback(() => {
    // 使用经纬度判断是否授权成功
    const code = parseInt(locationMsg?.data?.adCode);
    const cityCode = Math.floor(code / 100) + "";
    const provinceCode = Math.floor(code / 10000) + "";
    let province = "";
    let city = "";
    let matchingCityCode: any = 0;
    provincesCitiesData?.forEach((provinceItem) => {
      if (provinceItem.value == provinceCode) {
        provinceItem.children.forEach((cityItem) => {
          // 兼容数据库中 上海 的citycode只有两位的情况
          if (cityItem.value == provinceCode) {
            matchingCityCode = provinceItem.value;
            city = cityItem.label;
            province = provinceItem.label;
          }
          if (cityItem.value == cityCode) {
            matchingCityCode = cityItem.value;
            city = cityItem.label;
            province = provinceItem.label;
          }
        });
        // 直辖市匹配不到城市时，兜底取该直辖市下第一个城市
        if (
          matchingCityCode === 0 &&
          MUNICIPALITY_PROVINCE_CODES.includes(`${provinceCode}`)
        ) {
          const firstCity = provinceItem.children[0];
          if (firstCity) {
            matchingCityCode = firstCity.value;
            city = firstCity.label;
            province = provinceItem.label;
          }
        }
      }
    });
    // 处理位置信息
    let tmp = {
      cityCode: matchingCityCode + "",
      province,
      city,
    };
    localStorage.setItem("__das_es_location", JSON.stringify(tmp));
    console.log(tmp, "存储定位获取的地址信息，localtionStorge");
    setSelfArrivalCity({
      cityCode: matchingCityCode,
      cityName: city,
      provinceName: province,
      address: "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationMsg, provincesCitiesData]);

  const getShopListByCityCode = useCallback(
    async (cityCode) => {
      try {
        const locationItem = JSON.parse(
          localStorage.getItem("current_lng_and_lat") || "{}"
        );
        const shopList: any = await request(
          "/public/v2/module/maintenance/v2/shop/listShop",
          {
            cityCode,
            vin: baseInfo.frameNumber,
            sort: curTab === 0 ? 1 : 2, // 排序类型，1为综合排序，2为距离优先，默认按综合排序
            serviceItems,
            eventCode,
            childServiceItems,
            timeGranularity: 30, // 预约粒度：30 分钟，与新版对齐
            ...(selfArrivalCity?.address
              ? {
                  lng: locationItem?.longitude ?? null,
                  lat: locationItem?.latitude ?? null,
                }
              : {}),
          },
          "POST",
          {
            useCustomUrl: true,
          }
        );
        setCityStoreList(shopList);
      } catch (e) {
        console.error("getShopList errrrrrrrrrrrr", e);
        setIsError(true);
        setErrorMsg(e.message);
      } finally {
        setIsLoading(false);
      }
    },
    [baseInfo.frameNumber, curTab, serviceItems, eventCode, childServiceItems, selfArrivalCity]
  );

  /**获取定位失败时需要先获取专属门店及城市，如果没有才默认广州 */
  const queryExclusiveShop = useCallback(async () => {
    try {
      const rsp: any = await request(
        "/public/v2/shop/getDefaultShopAndCity",
        {
          vin: baseInfo.frameNumber,
        },
        "POST",
        {
          useCustomUrl: true,
        }
      );

      if (rsp.cityCode) {
        setSelfArrivalCity({
          cityCode: rsp.cityCode,
          cityName: rsp.cityName,
          address: "",
        });
      } else {
        console.log(
          "获取专属门店失败",
          rsp,
          "\n 设置adCode为默认 DEFAULT_CITY_CODE",
          DEFAULT_CITY_CODE
        );
        setLocationMsg({
          data: {
            adCode: DEFAULT_CITY_CODE,
          },
        });
      }
    } catch (e) {
      console.log(
        "获取专属门店错误",
        "\n 设置adCode为默认 DEFAULT_CITY_CODE",
        DEFAULT_CITY_CODE
      );
      setLocationMsg({
        data: {
          adCode: DEFAULT_CITY_CODE,
        },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseInfo.frameNumber]);

  const onTapSwitchCity = () => {
    history.push(
      `${history.location.pathname}${history.location.search}#select-cities`
    );
    sendReport({
      mcode: "切换城市点击",
      point: "P11185`B002",
    });
  };

  const onStoreSelected = (shopInfo) => {
    setDatesContentOfStoreTab(null);
    setDatesStoreContentOfDateTab(null);
    setStoreContentOfStoreTab(shopInfo);
    setModifyOrderArriveStoreTime(0);
    setModifyOrderShopCode("");
    setContentEdited(true);
    sendReport({
      mcode: "门店列表点击",
      point: "P11185`B003",
    });
    history.goBack();
  };
  const locaction = useMemo(() => {
    if (selfArrivalCity?.address) {
      return (
        <div className="city-switch-field-address">
          <PositionIcon color="#7BAE3F" />
          <div className="city-switch-field-text">
            {selfArrivalCity?.address}
          </div>
        </div>
      );
    }
    return selfArrivalCity?.cityName || "";
  }, [selfArrivalCity]);

  const reload = useCallback(() => {
    setIsError(false);
    setErrorMsg("");
    const cityCode = selfArrivalCity?.cityCode || locationMsg?.data?.adCode;
    getShopListByCityCode(cityCode);
  }, [selfArrivalCity, locationMsg, getShopListByCityCode]);

  useEffect(() => {
    if (provincesCitiesData?.length !== 0 && locationMsg?.data?.adCode) {
      getCityWithLocation();
    }
  }, [locationMsg, getCityWithLocation, provincesCitiesData]);

  useEffect(() => {
    if (!visible) return;
    if (!selfArrivalCity.cityCode) {
      getLocationFromApp()
        .then((res) => {
          setLocationMsg(res);
        })
        .catch((res) => {
          console.log(
            "获取定位失败",
            res?.message,
            "\n 设置adCode为默认 DEFAULT_CITY_CODE",
            DEFAULT_CITY_CODE
          );
          queryExclusiveShop();
        });
    } else {
      setIsLoading(true);
      getShopListByCityCode(selfArrivalCity.cityCode);
    }
  }, [selfArrivalCity, getShopListByCityCode, queryExclusiveShop, visible]);

  useEffect(() => {
    if (!visible) return;
    const cityCode = locationMsg?.data?.adCode;
    if (!cityCode) return;
    getShopListByCityCode(cityCode);
  }, [locationMsg, getShopListByCityCode, visible]);

  if (!visible) return null;

  if (isError) {
    return <ErrorPlaceholder message={errorMsg} getData={reload} />;
  }

  return (
    <div className="store-selector-container">
      <div className="store-list-wrapper">
        <div className="title-field">
          <div className="title-text">当前城市</div>
          {selfArrivalCity && (
            <div className="city-switch-field" onClick={onTapSwitchCity}>
              <span>{locaction}</span>
              <i className="switch-icon" />
            </div>
          )}
        </div>
        <div className="store-options-list">
          <Tabs
            id="custom-nav-comp"
            selectedIndex={ORDER_TAB_MAP.COMPREHENSIVE}
            selectedTabClassName="active"
            onSelect={() => {}}
            forceRenderTabsPanel
          >
            <TabList>
              <div className="tab-list">
                {ORDER_TAB_LIST.map((tabItem, tabIndex) => {
                  return (
                    <Tab key={tabItem.id}>
                      <div
                        className={classnames("tab-item", {
                          "selected-tab": tabIndex === curTab,
                        })}
                        onClick={() => {
                          if (tabIndex === curTab) return;
                          setCurTab(tabIndex);
                        }}
                      >
                        {tabItem.name}
                      </div>
                    </Tab>
                  );
                })}
              </div>
            </TabList>
          </Tabs>
          {!isLoading &&
            cityStoreList &&
            cityStoreList.map((shopItem) => {
              return (
                <StoreOptionCard
                  key={shopItem.code}
                  shopInfo={shopItem}
                  checked={!!shopItem.checked}
                  disabled={!!shopItem.groupFive}
                  onSelected={onStoreSelected}
                />
              );
            })}
        </div>
        {isLoading && (
          <div className="loading-field">
            <CommonLoadingComp />
          </div>
        )}
        {!isLoading && cityStoreList.length === 0 && (
          <div className="empty-field">
            <EmptyPlaceHolder />
          </div>
        )}
      </div>
    </div>
  );
}

function StoreOptionCard(props) {
  const { shopInfo, disabled = false, onSelected = () => {} } = props;

  const openMap = (data) => {
    const { name, lat, lot } = data;
    jsbridge.callHandler("navigate", {
      label: name,
      latitude: Number(lat),
      longitude: Number(lot),
    });

    sendReport({
      mcode: "门店地图点击",
      point: "P11185`B005",
    });
  };
  const onItemSelectHandler = (e) => {
    e.stopPropagation();
    if (disabled) return;
    onSelected(shopInfo);
  };

  return (
    <div
      className={classNames("store-option-item", {
        "store-disabled": disabled,
      })}
      onClick={onItemSelectHandler}
    >
      <div className="main-content-field">
        <div className="store-title-field">
          <div>
            {`${shopInfo.name || "--"} `}
            {!!shopInfo.isUserDefaultShop && (
              <div className="spec-store-label">专属门店</div>
            )}
            {/* {
              shopInfo.tags && shopInfo.tags[0] === "常去" && (
                <div className="usual-store-label">常去门店</div>
              )
            } */}
          </div>
        </div>
        <div className="addr-field">
          {shopInfo.distance ? `${getDistanceText(shopInfo.distance)}｜` : ""}
          {shopInfo.linkAddr}
        </div>
        <div className="score-line">
          <ScoreLine scoreInfo={shopInfo?.score} />
        </div>

        {shopInfo?.shopTags?.length > 0 ? (
          <div className="labels-field">
            {shopInfo?.shopTags.map((tag, i) => {
              return (
                <div key={i} className="tag-item">
                  {i === 0 ? "" : "｜"}
                  {tag}
                </div>
              );
            })}
          </div>
        ) : null}
        <div className="actions-field">
          {!!shopInfo.lat && !!shopInfo.lot && (
            <div
              className="nav-btn"
              onClick={(e) => {
                e.stopPropagation();
                openMap({
                  name: shopInfo.name,
                  lat: shopInfo.lat,
                  lot: shopInfo.lot,
                });
              }}
            />
          )}
          {!!shopInfo.linkTel && shopInfo.linkTel !== "0" && (
            <a
              href={`tel:${shopInfo.linkTel}`}
              className="info-content"
              onClick={(e) => {
                e.stopPropagation();
                sendReport({
                  mcode: "门店电话点击",
                  point: "P11185`B004",
                });
              }}
            >
              <div className="phone-btn" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
